import { Container } from "pixi.js";
import { createNoteEffect } from "./registry";
import type { NoteEffect, NoteEffectFrame, NoteEffectStyle } from "./types";

/**
 * Top-level note-effects layer. Owns the active effect strategy and swaps
 * it on style change. Hosts a private Container so the strategy can manage
 * its own children freely without touching the parent stage.
 */
export class NoteEffectsLayer {
  private container: Container;
  private effect: NoteEffect;
  private style: NoteEffectStyle;

  constructor(parent: Container, initialStyle: NoteEffectStyle) {
    this.container = new Container();
    parent.addChild(this.container);

    this.style = initialStyle;
    this.effect = createNoteEffect(initialStyle, this.container);
  }

  setStyle(style: NoteEffectStyle): void {
    if (style === this.style) {
      return;
    }

    this.effect.destroy();
    this.style = style;
    this.effect = createNoteEffect(style, this.container);
  }

  update(frame: NoteEffectFrame): void {
    this.effect.update(frame);
  }

  isAnimating(): boolean {
    return this.effect.isAnimating();
  }

  destroy(): void {
    this.effect.destroy();
    this.container.destroy({ children: true });
  }
}
